import { Reino } from "./Reino";

export interface Unidade {
  id: number
  nome: string
  sigla: string
}

export interface UnidadeDetalhada extends Unidade {
  reino: Reino
}

export class OrdenadorUnidade {
  static removerRepetidosEOrdernar(unidades: Unidade[]) {
    // Set cujo o hash é o id
    let idUnidades: {[key: number]: Unidade} = {};

    unidades.map(it => idUnidades[it.id] = it)
    
    return Object.values(idUnidades).sort((a, b) => a.sigla.localeCompare(b.sigla));
  }
}